<template>
  <div class="offers-page--main-wrapper product-desc">
    <top-header></top-header>

    <div class="offers-page--outer-wrapper mt-25" >
		<!--<div class="collections-page--header-wrapper">
        <b-container>
         
          <b-img style="width:100%" 
            :src="$root.MEDIAPATH+'category-banner/cosmetics.jpg'"
            alt=""
            class="offers-page-feature-banner offers-page-feature-banner--cosmetics"
          ></b-img>
        </b-container>
      </div>  -->

    </div>
		 <top-footer></top-footer>
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

//import Footer from "@/components/footer.vue";
/* import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
import ProductOffer from "@/components/product-offer.vue";
import AddtocartButton from "@/components/addtocartButton.vue"; */
//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style

export default {
  name: "offers-page-cosmetics",
  
	props: {
    
	},
	
	beforeCreate: function () {
   
  }, 
   watch: {
      
    },
  components: {
    "top-header": Header,
    "top-footer": Footer,
	
  },
  mounted(){
		this.initload();
	},
  data() {
    return { 
		
    };
  },
	methods: {
		initload(){
			var self = this;
			var provider = self.$route.params.provider;
			console.log(provider);
			console.log(self.$route.query);
			
		}
	},
  metaInfo() {
        //console.log('-------META INFO-------');
		//console.log('dev'+JSON.stringify(this.metaInfoList[this.$route.params.category]));
		let titleMeta = 'Alluraa';
		let descriptionMeta ='Alluraa';
		/*if(this.metaInfoList[this.$route.params.category]){
		let getTitle = this.metaInfoList[this.$route.params.category].title;
		let getdescription = this.metaInfoList[this.$route.params.category].description;
		
			if(getTitle){
				titleMeta = getTitle;
			}
			if(getdescription){
				descriptionMeta = getdescription;
			}
		} */
		
		
		return{
			
			title: titleMeta,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				/* { name: 'keywords', content: this.metadata.keywords }, */
				{ name: 'description', content: descriptionMeta},
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>

<style scoped lang="scss">

</style>